export const endpointGroups = Object.freeze({
  QUIZ_QUESTION: 'quiz/question',
  QUIZ_GRAPH_POSITION: 'quiz/graphPosition',
  QUIZ_INTERSTITIAL: 'quiz/interstitial',
})

export default endpointGroups
